import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { ExportSettingsGitModel, ExportStoreModel } from './export.model';

@Injectable({ providedIn: 'root' })
export class ExportGitService extends AbstractFeatureGitService<ExportStoreModel, Y42GitFolders.Export> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      name: 'Export-Git',
      basePath: getY42GitPath(Y42GitFolders.Export),
      errorHandlerService,
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: ExportSettingsGitModel,
        },
      },
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',

          models: {
            '.y42': {
              'secret.enc': {
                storeModelPropertyName: 'secret',
              },
            },
          },
        },
        2: {
          modelType: 'folder',
        },
      },
    });
  }

  readonly getCredentialsPath = (id: ExportStoreModel['$name']) => this.getPath(id, '.y42/secret.enc');

  async deleteExportAuthorization(exportId: ExportStoreModel['$name']) {
    const credentialsPath = this.getCredentialsPath(exportId);
    await this.git.deleteFile({ path: credentialsPath });
    await this.git.commit('exports: Revoke Access', [credentialsPath]);
  }
}
